import useLockBodyScroll from '@libs/hooks/useLockBodyScroll';
import { useMediaQuery } from '@providers/MediaQueryProvider';

import { useAuth } from '@features/auth/hooks/useAuth';

import { PairingSearchWidget } from '../pairing/PairingSearch/PairingSearchWidget';
import { OnlineGamesModal } from './OnlineGamesModal';

export function OnlineGamesModalWidget({
  className,
  position,
  closeText,
  onClose,
}: {
  className?: string;
  position?: 'centered' | 'static';
  closeText?: string;
  onClose?: () => void;
}) {
  const mediaQuery = useMediaQuery();
  const isMobile = mediaQuery === 'mobile' || mediaQuery === 'tablet';

  const { isAuthenticated } = useAuth();

  useLockBodyScroll(isMobile);

  return (
    <OnlineGamesModal
      className={className}
      position={position}
      isMobile={isMobile}
      closeText={closeText}
      onClose={onClose}
    >
      <PairingSearchWidget isAuthenticated={isAuthenticated} />
    </OnlineGamesModal>
  );
}
